module.exports = __webpack_public_path__ + "static/media/sponsor.08c0767b.md";